import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  textCell: {
    display: 'inline-block',
    fontWeight: 'bolder',
    fontSize: '1rem',
    color: '#3C419A',
    overflow: 'hidden',
    width: '160px',
    paddingTop: '5px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
  checkbox: {
    margin: '-4px',
    '& .MuiSvgIcon-root': { fontSize: 20 },
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#3560FF',
        padding: '1px 1px 1px 1px',
      },
    },
  },
}));
